import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";

function ProgramacionHoraria({ idS, idE, onCreate }) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [fechaHora, setFechaHora] = useState("");
  const [servicio, setServicio] = useState("");
  const [actividad, setActividad] = useState("");
  const [observaciones, setObservaciones] = useState("");

  // Fecha actual Colombia
  useEffect(() => {
    const ahora = new Date();
    const formatted = new Intl.DateTimeFormat("sv-SE", {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
      .format(ahora)
      .replace(" ", "T");

    setFechaHora(formatted);
  }, []);

  const guardar = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        "https://suadesarrollo.azurewebsites.net/api/creaVisitaProgramacion",
        {
          fecha: fechaHora,
          horario: new Date(fechaHora).toISOString(),
          servicio,
          actividad,
          cumplimiento: "En Revisión",
          observaciones,
          solicitudId: idS,
          evaluadorId: idE,
        },
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );

      Swal.fire("✅ Guardado", "Evento creado correctamente", "success");

      setIsOpen(false);
      onCreate(); // 🔥 refresca la tabla
    } catch (error) {
      Swal.fire("❌ Error", "No se pudo crear el evento", "error");
      console.error(error);
    }
  };

  return (
    <>
      <button className="btn btn-success mb-3" onClick={() => setIsOpen(true)}>
        Añadir evento
      </button>

      <ReactModal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)}>
        <br></br>
        <br></br>
        <br></br>
        <h5 className="text-primary">Agregar visita / evento</h5>

        <form onSubmit={guardar}>
          <input
            className="form-control mb-2"
            placeholder="Servicio"
            value={servicio}
            onChange={(e) => setServicio(e.target.value)}
            required
          />

          <input
            className="form-control mb-2"
            placeholder="Actividad"
            value={actividad}
            onChange={(e) => setActividad(e.target.value)}
            required
          />

          <input
            className="form-control mb-2"
            placeholder="Observaciones"
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
          />

          <TextField
            label="Fecha y hora"
            type="datetime-local"
            value={fechaHora}
            onChange={(e) => setFechaHora(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />

          <div className="text-end mt-3">
            <button
              className="btn btn-secondary me-2"
              type="button"
              onClick={() => setIsOpen(false)}
            >
              Cancelar
            </button>
            <button className="btn btn-primary" type="submit">
              Guardar
            </button>
          </div>
        </form>
      </ReactModal>
    </>
  );
}

export default ProgramacionHoraria;
